module.exports = __webpack_public_path__ + "static/media/avurudu.3e7f775f.png";